"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6494],{

/***/ 623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const LoadingBar = ()=>{
    const shimmerStyle = {
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-2 bg-blue-100 overflow-hidden relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full h-full absolute transform translate-x-0 bg-gradient-to-r from-transparent via-blue-500 to-transparent",
            style: shimmerStyle
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingBar);


/***/ }),

/***/ 29039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ carousel_Carousel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./libs/Utility/parsers.tsx
var parsers = __webpack_require__(40654);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(13913);
;// CONCATENATED MODULE: ./components/carousel/VideoModal.tsx
/* eslint-disable react-hooks/rules-of-hooks */ 



const VideoModal = (param)=>{
    let { isOpen , videoUrl , onClose , isImage  } = param;
    if (!isOpen) return null;
    const [youtubeId, setYoutubeId] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        setYoutubeId((0,parsers/* getYoutubeVideoId */.P9)(videoUrl));
    }, [
        videoUrl
    ]);
    const isYouTubeVideo = (0,parsers/* isYoutubeUrl */.Qd)(videoUrl);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4",
        onClick: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative w-full max-w-4xl bg-black",
            onClick: (e)=>e.stopPropagation(),
            children: [
                isImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: videoUrl,
                    alt: "",
                    width: "100%",
                    height: "100%",
                    style: {
                        maxHeight: "100%",
                        maxWidth: "100%"
                    }
                }),
                isYouTubeVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTube_esm/* default */.Z, {
                    videoId: youtubeId,
                    iframeClassName: "w-full h-full",
                    style: {
                        height: "550px"
                    },
                    className: "flex w-full overflow-hidden",
                    opts: {
                        height: "100%",
                        width: "100%"
                    }
                }),
                !isYouTubeVideo && !isImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    src: videoUrl,
                    controls: true,
                    autoPlay: true,
                    className: "w-full h-full"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: onClose,
                    className: "absolute right-2 top-2 rounded-full py-1 px-2 text-sm font-semibold text-white bg-red-600 hover:bg-red-700",
                    children: "X"
                })
            ]
        })
    });
};
/* harmony default export */ var carousel_VideoModal = (VideoModal);

// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./components/base/RichTextDisplay.tsx
var RichTextDisplay = __webpack_require__(25536);
// EXTERNAL MODULE: ./components/ui/MediaThumbnail.tsx
var MediaThumbnail = __webpack_require__(26052);
;// CONCATENATED MODULE: ./components/carousel/Carousel.tsx








const Carousel = (param)=>{
    let { items , fixedHeight =true , show =true , className ="relative" , width , slideshow =false  } = param;
    var ref, ref1;
    const timer = (0,react.useRef)();
    const [isModalOpen, setIsModalOpen] = (0,react.useState)(false);
    const [currentMediaUrl, setCurrentMediaUrl] = (0,react.useState)("");
    const [currIndex, setCurrIndex] = (0,react.useState)(0);
    const [isImage, setIsImage] = (0,react.useState)(false);
    const [content, setContent] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        const parseMedia = async ()=>{
            const payload = await Promise.all(items.map(async (item)=>{
                return {
                    ...item,
                    isImage: await (0,parsers/* getMediaType */.V4)(item.url) === "IMAGE"
                };
            }));
            setContent(payload);
        };
        parseMedia();
    }, [
        items
    ]);
    const handleMediaClick = async (media)=>{
        const url = typeof media === "string" ? media : media.src;
        const isImage = await (0,parsers/* getMediaType */.V4)(url) === "IMAGE";
        setIsImage(isImage);
        setCurrentMediaUrl(url);
        setIsModalOpen(true);
    };
    const prevSlide = ()=>{
        pauseSlideshow();
        setCurrIndex((prevIndex)=>prevIndex === 0 ? items.length - 1 : prevIndex - 1);
    };
    const nextSlide = function() {
        let opt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            pause: true
        };
        if (opt.pause) pauseSlideshow();
        setCurrIndex((prevIndex)=>prevIndex === items.length - 1 ? 0 : prevIndex + 1);
    };
    const clearLoop = ()=>{
        if (timer.current) {
            clearInterval(timer.current);
            timer.current = undefined;
        }
    };
    const pauseSlideshow = ()=>{
        if (!slideshow) return;
        clearLoop();
        setTimeout(()=>{
            const loop = setInterval(()=>{
                nextSlide({
                    pause: false
                });
            }, 4000);
            timer.current = loop;
        }, 8000);
    };
    (0,react.useEffect)(()=>{
        if (slideshow) {
            const loop = setInterval(()=>{
                if (!slideshow) return;
                nextSlide({
                    pause: false
                });
            }, 4000);
            clearLoop();
            timer.current = loop;
        }
        return ()=>clearLoop();
    }, []);
    // useEffect(() => {
    //   if (timer.current) clearInterval(timer.current)
    //   return () => clearInterval(timer.current)
    // }, [])
    const carouselRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        const ele = carouselRef.current;
        let isPressing = false;
        let startX;
        const dragStart = (e)=>{
            document.onmousemove = dragMove;
            document.ontouchmove = dragMove;
            document.onmouseup = dragEnd;
            document.ontouchend = dragEnd;
            document.ontouchcancel = dragEnd;
            isPressing = true;
            if (e.type === "touchstart") {
                startX = e.touches[0].pageX;
            } else if (e.type === "mousedown") {
                startX = e.pageX;
            }
        };
        const dragMove = (e)=>{
            if (isPressing) {
                dragEnd();
                let currentX = startX;
                if (e.type === "touchmove") {
                    currentX = e.touches[0].pageX;
                } else if (e.type === "mousemove") {
                    currentX = e.pageX;
                }
                if (currentX < startX) nextSlide();
                if (currentX > startX) prevSlide();
            }
        };
        const dragEnd = ()=>{
            document.onmousemove = null;
            document.onmouseup = null;
            document.ontouchmove = null;
            document.ontouchend = null;
            document.ontouchcancel = null;
            isPressing = false;
        };
        if (ele) {
            ele.addEventListener("touchstart", dragStart);
            ele.addEventListener("mousedown", dragStart);
        }
        return ()=>{
            if (ele) {
                ele.removeEventListener("touchstart", dragStart);
                ele.removeEventListener("mousedown", dragStart);
            }
        };
    }, [
        carouselRef.current
    ]);
    if (!show) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    const prevIndex = currIndex - 1 < 0 ? items.length - 1 : currIndex - 1;
    const nextIndex = currIndex + 1 > items.length - 1 ? 0 : currIndex + 1;
    const targetIndexes = [
        prevIndex,
        currIndex,
        nextIndex
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: carouselRef,
        className: "".concat(className, " h-full relative"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_VideoModal, {
                isOpen: isModalOpen,
                videoUrl: currentMediaUrl,
                onClose: ()=>setIsModalOpen(false),
                isImage: isImage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex h-full w-full justify-center items-center relative max-w-[900px] mx-auto lg:max-h-[300px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-full h-[60em] max-w-[900px] md:h-[30em] transition-transform ease-out duration-500 relative justify-center items-center",
                        children: content.map((item, index)=>{
                            const isImage = item.isImage;
                            const isTarget = targetIndexes.includes(index);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-none absolute ".concat(fixedHeight ? "size-[35em] md:h-[28em] md:w-[28em] lg:max-w-[200px] lg:max-h-[200px]" : "h-auto w-[".concat(width, "]"), " cursor-pointer ").concat(index),
                                style: {
                                    opacity: items.length < 3 && index !== currIndex ? "0" : isTarget ? "1" : "0",
                                    position: "absolute",
                                    transform: "perspective(75em) translateX(".concat(items.length < 3 ? "0%" : index == prevIndex ? "-100%" : index == nextIndex ? "100%" : "0%", ") rotateY(").concat(items.length < 3 ? "0deg" : prevIndex === index ? "-40deg" : nextIndex === index ? "40deg" : isTarget ? "0deg" : index < currIndex ? "-90deg" : "90deg", ") scale(").concat(index === currIndex ? "1" : "0.7", ")"),
                                    transition: "transform 500ms ease-in-out, opacity 200ms linear ".concat(isTarget ? "300ms" : "0ms"),
                                    zIndex: isTarget ? index === currIndex ? "19" : "15" : "10"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full h-full flex items-center justify-center relative",
                                    onClick: ()=>{
                                        item.onClick ? item.onClick(item) : handleMediaClick(item.url || "");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaThumbnail/* MediaThumbnail */.U, {
                                            media: item.url,
                                            alt: item.title,
                                            size: "any",
                                            className: "h-full ".concat(width ? "w-full" : "w-auto", " bg-none rounded-2xl")
                                        }, item.title.trim().replaceAll(" ", "_").toLowerCase()),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "".concat(isImage && "hidden", " absolute text-white text-6xl"),
                                            children: "▶"
                                        })
                                    ]
                                })
                            }, index);
                        })
                    }),
                    items.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: prevSlide,
                                className: "absolute top-[50%] left-0 p-2 rounded-full bg-white text-gray-800 hover:bg-gray-200 z-[20]",
                                style: {
                                    transform: "translateY(-50%)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowBack */.u1R, {
                                    className: "text-xl"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: ()=>nextSlide(),
                                className: "absolute top-[50%] right-0 p-2 rounded-full bg-white text-gray-800 hover:bg-gray-200 z-[20]",
                                style: {
                                    transform: "translateY(-50%)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowForward */.hjJ, {
                                    className: "text-xl"
                                })
                            })
                        ]
                    })
                ]
            }),
            items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex flex-col w-full px-6 sm:px-10 md:px-12 lg:px-16 mt-10 mx-auto text-center ml-4 mr-4 md:ml-0 md:mr-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "text-2xl font-medium w-full",
                        children: (ref = items[currIndex]) === null || ref === void 0 ? void 0 : ref.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "text-sm mt-3 font-small w-full max-w-[900px] mx-auto text-center h-[200px] md:h-[50px] lg:h-[0px]",
                        style: {
                            whiteSpace: "pre-line"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextDisplay/* default */.Z, {
                            descriptionJson: (ref1 = items[currIndex]) === null || ref1 === void 0 ? void 0 : ref1.description
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var carousel_Carousel = (Carousel);


/***/ }),

/***/ 21867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51773);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5779);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);





const Card = (param)=>{
    let { children , className , onClick , imgSrc ="" , imgWidth =80 , imgHeight =80 , title ="Card" , selected =false , text , fixedWidth =true , ratio ="aspect-square" , disabled =false  } = param;
    const { theme , StaticColours  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
        className: "flex flex-col items-center text-center px-5 py-5 rounded-md ".concat(className, " ").concat(onClick && !disabled ? "cursor-pointer" : "cursor-not-allowed"),
        style: {
            backgroundColor: disabled ? StaticColours.disabled : selected ? StaticColours.v2.light_blue : theme.foregroundColour,
            ...fixedWidth ? {
                width: "320px"
            } : {}
        },
        onClick: disabled ? undefined : onClick,
        children: [
            title !== "Card" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                className: "text-xl mt-1 mb-5",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                show: !!imgSrc,
                className: "flex items-center rounded-md bg-white ".concat(fixedWidth ? "w-full" : "", " h-auto ").concat(ratio),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    className: "w-full h-full ".concat(disabled && "saturate-0"),
                    style: {
                        objectFit: "fill"
                    },
                    src: imgSrc,
                    alt: title,
                    width: imgWidth,
                    height: imgHeight
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                show: !!text,
                className: "text-xs break-words pt-4 px-4",
                style: {
                    width: "18rem"
                },
                children: text
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                show: !!children,
                className: "mt-6 text-xl size-full",
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Card);


/***/ }),

/***/ 39618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73912);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5779);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6686);






/**
 * Primary UI component for text input
 */ const TextInput = (param)=>{
    let { label , placeholder , value ="" , onChange , className , hint , validations , required , type ="text" , border ="border" , onKeyDown , onBlur , max , min , textColour , disabled , labelBgColour , testid , name , tooltip , show =true , customClassLabel ="" , error , autoComplete  } = param;
    const errorMessage = error !== null && error !== void 0 ? error : (0,_Validations__WEBPACK_IMPORTED_MODULE_5__/* .validate */ .G)(value, validations);
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg)();
    const [showTooltip, setShowTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        // Autohide tooltip if the input is not required.
        if ((tooltip === null || tooltip === void 0 ? void 0 : tooltip.toLowerCase().includes("require")) && !required) setShowTooltip(false);
    }, [
        tooltip,
        required
    ]);
    const backgroundColour = labelBgColour ? labelBgColour : theme.backgroundColour;
    if (value === null) value = "";
    const input = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
        "data-testid": testid !== null && testid !== void 0 ? testid : null,
        required: required,
        value: value,
        onKeyDown: onKeyDown,
        onBlur: onBlur,
        onChange: (e)=>{
            const isInvalid = (0,_Validations__WEBPACK_IMPORTED_MODULE_5__/* .validate */ .G)(e.target.value, validations) !== "";
            onChange && onChange(e.target.value, isInvalid);
        },
        max: max,
        disabled: disabled,
        min: min,
        type: type,
        placeholder: placeholder,
        autoComplete: autoComplete !== null && autoComplete !== void 0 ? autoComplete : label,
        id: label,
        className: "rounded-2xl transition-all bg-transparent ".concat(border, " ").concat(errorMessage ? "text-red-500 border-red-500" : "", " rounded px-4 py-4 text-sm outline-none placeholder-gray-500 ").concat(disabled ? "!text-gray-500" : ""),
        style: {
            color: textColour
        }
    });
    const labelRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const [computedStyle, setComputedStyle] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        if (labelRef.current) {
            const computed = window.getComputedStyle(labelRef.current);
            const parentBg = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_3__/* .getParentBg */ .WI)(labelRef.current);
            setComputedStyle({
                ...computed,
                parentBg
            });
        }
    }, [
        labelRef.current
    ]);
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: [
            "flex flex-col my-4",
            className
        ].join(" "),
        style: {
            color: textColour
        },
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                ref: labelRef,
                className: "absolute text-sm mb-2 ml-2 z-10 ".concat(required ? "pl-2" : "px-2", " transition-all ").concat(errorMessage ? "text-red-500" : "", " !backdrop-blur-md"),
                style: {
                    transform: "translateY(-50%)"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    show: showTooltip,
                    tooltip: tooltip,
                    className: "flex flex-col",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "z-10 ".concat(customClassLabel, " ").concat(required ? "after:content-['*'] after:mx-2 after:text-red-500" : ""),
                        children: label
                    })
                })
            }),
            input,
            errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                textColour: "foregroundTextColour",
                className: "transition-all text-red-500 text-xs font-bold mt-1",
                children: errorMessage
            }),
            hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mt-1 mb-4 ml-2 text-xs",
                style: {
                    color: textColour
                },
                children: hint
            })
        ]
    });
};


/***/ }),

/***/ 26052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ MediaThumbnail; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _libs_Utility_parsers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40654);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _public_images_ForummLogo_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63696);
/* harmony import */ var _components_base_LoadingSpinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38999);





const MediaThumbnail = (param)=>{
    let { show =true , style ={} , media , key , size ="sm" , className ="" , alt , timeout =3000 , onClick =(e)=>{}  } = param;
    const [thumbnail, setThumbnail] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const sizeClasses = {
        any: "",
        xs: "h-6 w-6",
        sm: "h-8 w-8",
        md: "h-10 w-10",
        lg: "h-12 w-12",
        xl: "h-14 w-14"
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        (async ()=>{
            if (media) {
                setLoading(true);
                await (0,_libs_Utility_parsers__WEBPACK_IMPORTED_MODULE_1__/* .getContentThumbnail */ .Lb)(media).then((data)=>{
                    setThumbnail(data);
                    setLoading(false);
                }).catch((err)=>{
                    console.error(err);
                    setLoading(false);
                });
            }
        })();
    }, [
        media
    ]);
    setTimeout(()=>setLoading(false), timeout);
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (!thumbnail && loading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_LoadingSpinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: "".concat(sizeClasses[size], " ").concat(className)
    });
    if (!thumbnail) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_images_ForummLogo_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: "".concat(sizeClasses[size], " ").concat(className)
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        style: style,
        onClick: (e)=>onClick(e),
        className: "".concat(sizeClasses[size], " ").concat(className, " object-cover"),
        alt: alt !== null && alt !== void 0 ? alt : "Media thumbnail",
        src: thumbnail,
        draggable: false
    }, key);
};


/***/ }),

/***/ 39615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DonationPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./libs/Utility/util.ts + 1 modules
var util = __webpack_require__(50160);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./public/images/default-thumbnail.png
var default_thumbnail = __webpack_require__(96963);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 2 modules
var useQuery = __webpack_require__(6812);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./layouts/Wrapper.tsx + 9 modules
var Wrapper = __webpack_require__(44066);
// EXTERNAL MODULE: ./node_modules/@stripe/stripe-js/dist/stripe.esm.js
var stripe_esm = __webpack_require__(91291);
// EXTERNAL MODULE: ./graphql/events/GetEventByDonationUrl.ts
var GetEventByDonationUrl = __webpack_require__(95746);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./components/base/TextLink.tsx
var TextLink = __webpack_require__(82316);
// EXTERNAL MODULE: ./libs/useTheme.ts + 1 modules
var useTheme = __webpack_require__(5779);
;// CONCATENATED MODULE: ./components/base/ProgressWheel.tsx




const ProgressWheel = (param)=>{
    let { fillColor , bgColor , diameter =140 , percentageComplete  } = param;
    const { theme , StaticColours  } = (0,useTheme/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "rounded-full relative flex justify-center items-center",
        style: {
            width: diameter,
            height: diameter,
            background: fillColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "rounded-full absolute flex justify-center items-center text-5xl",
                style: {
                    width: diameter * 0.9,
                    height: diameter * 0.9,
                    background: theme.foregroundColour,
                    color: bgColor
                },
                children: [
                    Math.round(percentageComplete),
                    "%"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "w-full h-full absolute top-0 left-0",
                xmlns: "http://www.w3.org/2000/svg",
                version: "1.1",
                style: {
                    transform: "rotate(-90deg)",
                    fill: "none",
                    stroke: bgColor,
                    strokeWidth: diameter * 0.05,
                    strokeDasharray: Math.PI * diameter,
                    strokeDashoffset: Math.PI * diameter * (1 - percentageComplete / 100),
                    strokeLinecap: "butt",
                    strokeOpacity: percentageComplete > 0 ? "100" : "0",
                    transition: "all ease-out ".concat(percentageComplete * 10 + 50, "ms")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: diameter / 2,
                    cy: diameter / 2,
                    r: diameter * 0.95 / 2
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/base/LoadingSpinner.tsx + 1 modules
var LoadingSpinner = __webpack_require__(38999);
// EXTERNAL MODULE: ./libs/useAuth.ts + 25 modules
var useAuth = __webpack_require__(97358);
;// CONCATENATED MODULE: ./components/donation/DonationProgressWheel.tsx










const DONATION_WHEEL_CONFIG = {
    disabled: [
        "d9232843-4c2d-4f7f-b2d8-ab89499cd9d1",
        "d9232843-4c2d-4f7f-b2d8-ab89499cd9d2",
        "cd54965b-4538-44bf-b177-1f0837706cee",
        "b9504ce6-f68e-4f31-a6cf-df99d55a113e",
        "196ae88a-ab1f-42d9-a26f-ca9f9122fc87",
        "a4d4f37e-f4fe-41d5-863d-d9d254e404a1"
    ]
};
const DonationProgressWheel = (param)=>{
    let { currentAmount , donationGoal , numberOfDonators , currency , isLoading , donationAction , merchantNotConfigured , loadingMerchantInfo  } = param;
    var ref, ref1;
    const { theme , StaticColours  } = (0,useTheme/* useTheme */.Fg)();
    const router = (0,next_router.useRouter)();
    const isDarkTheme = theme.type === "DARK";
    const defaultColor = isDarkTheme ? StaticColours.forumm_blue_light : StaticColours.v2.blue;
    const color = currentAmount >= donationGoal ? theme.successColour : defaultColor;
    const buttonTextColorClass = isDarkTheme ? "text-forumm-light-blue-dark" : "text-forumm-selected-menu-blue";
    const iconFillColor = isDarkTheme ? StaticColours.forumm_share_dark : StaticColours.v2.blue_share;
    const [shareButtonText, setShareButtonText] = (0,react.useState)("Share");
    const { profile  } = (0,useAuth/* useAuth */.aC)();
    const isAdmin = profile === null || profile === void 0 ? void 0 : (ref = profile.groups) === null || ref === void 0 ? void 0 : ref.includes("forumm-admin");
    const isOrganizer = profile === null || profile === void 0 ? void 0 : (ref1 = profile.groups) === null || ref1 === void 0 ? void 0 : ref1.includes("organizer");
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
            className: "flex items-center justify-center my-auto h-[486px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                size: "medium"
            })
        });
    }
    var ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex items-center justify-center flex-col px-4 space-y-2 mt-11 mb-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "mb-3 hover:animate-jello-horizontal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressWheel, {
                    fillColor: currentAmount >= donationGoal ? theme.successColour : theme.wheelColour,
                    bgColor: currentAmount >= donationGoal ? theme.successColour : theme.type === "DARK" ? StaticColours.forumm_blue_light : StaticColours.v2.blue,
                    diameter: 200,
                    percentageComplete: donationGoal === 0 ? 0 : currentAmount / donationGoal * 100
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "font-medium text-[36px] mb-2",
                style: {
                    color
                },
                children: [
                    (ref2 = currency === null || currency === void 0 ? void 0 : currency.symbol) !== null && ref2 !== void 0 ? ref2 : "$",
                    (0,util/* roundAmount */.Bq)(currentAmount)
                ]
            }),
            (isOrganizer || isAdmin) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "text-md",
                children: [
                    "Raised of",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        style: {
                            color
                        },
                        className: "font-medium",
                        children: [
                            (ref3 = currency === null || currency === void 0 ? void 0 : currency.symbol) !== null && ref3 !== void 0 ? ref3 : "$",
                            (0,util/* roundAmount */.Bq)(donationGoal)
                        ]
                    }),
                    " ",
                    "target by",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            color
                        },
                        className: "font-medium",
                        children: numberOfDonators
                    }),
                    " ",
                    "donations."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    marginTop: "40px"
                },
                children: [
                    !loadingMerchantInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: ()=>{
                            donationAction();
                        },
                        type: "primary",
                        title: "Donate",
                        className: "",
                        size: "full",
                        disabled: merchantNotConfigured
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        className: "w-[180px] mt-2 border-none ".concat(buttonTextColorClass, " text-xs flex items-center justify-center"),
                        title: shareButtonText,
                        textColor: theme.tealColour,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "13",
                            height: "16",
                            viewBox: "1 -1 12 15",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mr-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M11.375 0.601562H4.625C3.8 0.601562 3.125 1.27656 3.125 2.10156V11.1016C3.125 11.9266 3.8 12.6016 4.625 12.6016H11.375C12.2 12.6016 12.875 11.9266 12.875 11.1016V2.10156C12.875 1.27656 12.2 0.601562 11.375 0.601562ZM11.375 11.1016H4.625V2.10156H11.375V11.1016ZM0.125 10.3516V8.85156H1.625V10.3516H0.125ZM0.125 6.22656H1.625V7.72656H0.125V6.22656ZM5.375 14.1016H6.875V15.6016H5.375V14.1016ZM0.125 12.9766V11.4766H1.625V12.9766H0.125ZM1.625 15.6016C0.8 15.6016 0.125 14.9266 0.125 14.1016H1.625V15.6016ZM4.25 15.6016H2.75V14.1016H4.25V15.6016ZM8 15.6016V14.1016H9.5C9.5 14.9266 8.825 15.6016 8 15.6016ZM1.625 3.60156V5.10156H0.125C0.125 4.27656 0.8 3.60156 1.625 3.60156Z"
                            })
                        }),
                        type: "tertiary",
                        size: "small",
                        onClick: (e)=>{
                            navigator.clipboard.writeText("https://".concat(window.location.hostname).concat(router.asPath));
                            setShareButtonText("Copied!");
                            setTimeout(()=>{
                                setShareButtonText("Share");
                            }, 3000);
                            e.preventDefault();
                        }
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./libs/currencies.ts
var currencies = __webpack_require__(30530);
// EXTERNAL MODULE: ./libs/useOrganisationProfile.ts
var useOrganisationProfile = __webpack_require__(19058);
// EXTERNAL MODULE: ./node_modules/react-icons/go/index.esm.js
var index_esm = __webpack_require__(66653);
;// CONCATENATED MODULE: ./components/donation/DonationWall.tsx









const visibilityChoices = {
    NAME_AMOUNT: "Name & amount",
    NAME: "Name only",
    ANON: "Anonymous"
};
const getTimeSinceDonation = (time)=>{
    if (!time) return "";
    try {
        const timestamp = typeof time === "string" ? parseInt(time, 10) : time;
        const momentTime = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;
        return moment_default()(momentTime).fromNow();
    } catch (e) {
        console.warn({
            e
        });
        return "";
    }
};
const noDonationsPage = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
    className: "text-xl pt-4",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
        className: "flex flex-row",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
            className: "flex flex-col",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "flex flex-row space-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "text-xs md:text-sm",
                    children: "There are no donations yet, be the first!"
                })
            })
        })
    })
});
const DonationWall = (param)=>{
    let { donations , donationAction , customClassName  } = param;
    const [donationIndex, setDonationsIndex] = (0,react.useState)(1);
    const amountToShow = 5;
    const { theme , StaticColours  } = (0,useTheme/* useTheme */.Fg)();
    const color = theme.type === "DARK" ? StaticColours.forumm_blue_light : StaticColours.v2.blue;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex flex-col w-full p-2 overflow-y-auto max-h-[calc(90vh-17px)] ".concat(customClassName),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex flex-row items-center justify-between mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "font-normal text-3xl",
                        children: "Donation Wall"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "font-medium mr-6 md:mr-0",
                        children: [
                            (ref = donations === null || donations === void 0 ? void 0 : donations.length) !== null && ref !== void 0 ? ref : 0,
                            " donations"
                        ]
                    })
                ]
            }),
            donations.length < 1 ? noDonationsPage : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "flex flex-col flex-grow h-full overflow-y-auto scrollbar-custom",
                children: donations.sort((a, b)=>a.created && b.created ? a.created < b.created ? 1 : -1 : 0).map((dono, i)=>{
                    const { firstName , lastName , message , amount , created , currency , avatarUrl , coverFee , selectedProgram: programme , donation , visibility , fee  } = dono;
                    const donationAmount = (()=>{
                        try {
                            const donationval = parseFloat(donation);
                            const feeVal = parseFloat(fee);
                            if (!!donation && donationval > 0) {
                                if (coverFee === "no" || coverFee === "false") return donationval + feeVal;
                                return donationval;
                            }
                        } catch (err) {
                            console.log(err);
                            return amount;
                        }
                        return amount;
                    })();
                    const isAnon = (visibility === null || visibility === void 0 ? void 0 : visibility.toLowerCase()) === visibilityChoices.ANON.toLowerCase();
                    const showAmount = (visibility === null || visibility === void 0 ? void 0 : visibility.toLowerCase()) === visibilityChoices.NAME_AMOUNT.toLowerCase();
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "font-medium text-xl py-4 -mt-3 mr-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "flex flex-row w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            style: {
                                                width: "80px"
                                            },
                                            className: "flex flex-col mt-3 ml-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: avatarUrl !== null && avatarUrl !== void 0 ? avatarUrl : "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/heart-and-hand-donation-icon.png",
                                                alt: "Logo",
                                                width: 40,
                                                height: 40,
                                                className: "rounded-full object-cover h-[40px] border border-1"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "flex flex-col w-full",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "flex flex-row justify-between items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "text-sm text-sm font-medium mt-2 mb-4",
                                                            children: !isAnon ? firstName + " " + lastName : "Anonymous"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "text-xs font-light -mt-2 mr-6 xl:mr-2",
                                                            children: created ? getTimeSinceDonation("".concat(created)) : ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "flex flex-col justify-between -mt-2 mb-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        show: !!message,
                                                        className: "text-xs text-left font-light text-sm",
                                                        children: message
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "text-sm font-medium flex flex-row items-center",
                                                    style: {
                                                        color
                                                    },
                                                    children: [
                                                        !showAmount && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "donated to"
                                                        }),
                                                        showAmount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                " ",
                                                                currency ? currencies/* default */.Z === null || currencies/* default */.Z === void 0 ? void 0 : currencies/* default */.Z[currency === null || currency === void 0 ? void 0 : currency.toUpperCase()].symbol : "\xa3",
                                                                (donationAmount / 100).toFixed(2)
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                            show: !!programme,
                                                            className: "text-xs flex items-center gap-1 pl-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GoArrowRight */.e$1, {}),
                                                                programme
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "h-[2px] bg-gray-200 w-3/4 sm:w-full mx-auto"
                            })
                        ]
                    }, "".concat(i));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "flex flex-row space-x-2 pt-4 items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    show: donations.length > 5 && donationIndex * amountToShow >= donations.length,
                    className: "w-[180px]",
                    title: "Go Back",
                    type: "secondary",
                    size: "auto",
                    onClick: ()=>{
                        if (donationIndex * amountToShow >= donations.length) setDonationsIndex(1);
                    }
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/base/LoadingBar.tsx
var LoadingBar = __webpack_require__(623);
// EXTERNAL MODULE: ./node_modules/@stripe/react-stripe-js/dist/react-stripe.umd.js
var react_stripe_umd = __webpack_require__(86664);
// EXTERNAL MODULE: ./components/donation/DonationForm.tsx + 7 modules
var DonationForm = __webpack_require__(48814);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/events/eventDonationListTransactions.ts

const EVENT_DONATON_LIST_TRANSACTIONS = (0,_generated/* graphql */.B)("\n  query eventDonationListTransactions(\n    $eventId: String\n    $donationUrl: String\n    $eventName: String\n  ) {\n    eventDonationListTransactions(\n      eventId: $eventId\n      donationUrl: $donationUrl\n      eventName: $eventName\n    ) {\n      transactions {\n        firstName\n        lastName\n        amount\n        currency\n        eventId\n        eventName\n        message\n        coverFee\n        fee\n        donation\n        total\n        created\n        address\n        giftAid\n        selectedProgram\n        email\n        visibility\n        donorDob\n        paymentType\n      }\n    }\n  }\n");

// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./components/carousel/Carousel.tsx + 1 modules
var Carousel = __webpack_require__(29039);
;// CONCATENATED MODULE: ./components/carousel/prepareCarouselItems.ts
const defaultOptions = {
    coverImage: "https://assets.tumblr.com/images/default_header/optica_pattern_11.png",
    title: "Foundraising Title",
    description: "The program of inspirational talks stands out at our event. Experts share innovative visions about the future. In addition, interactive workshops offer practical skills to apply in real life."
};
const prepareCarouselItems = (param)=>{
    let { media , options  } = param;
    if (!options) options = defaultOptions;
    if (!options.coverImage) options.coverImage = defaultOptions.coverImage;
    if (!options.title) options.title = defaultOptions.title;
    if (!options.description) options.description = defaultOptions.description;
    const { coverImage , title , description  } = options;
    if (media.length === 0) return [];
    return media.map((item)=>{
        var _title, _description;
        return {
            url: item.url,
            title: (_title = item.title) !== null && _title !== void 0 ? _title : "",
            description: (_description = item.description) !== null && _description !== void 0 ? _description : ""
        };
    });
};

// EXTERNAL MODULE: ./components/base/RichTextDisplay.tsx
var RichTextDisplay = __webpack_require__(25536);
// EXTERNAL MODULE: ./components/event/Card.tsx
var Card = __webpack_require__(21867);
;// CONCATENATED MODULE: ./graphql/events/getFundrasingCSV.ts

const GET_FUNDRAISING_CSV = (0,_generated/* graphql */.B)("\n  query GetFundraisingCSV($eventId: String!) {\n    getFundraisingCSV(eventId: $eventId)\n  }\n");

// EXTERNAL MODULE: ./graphql/__generated/graphql.ts
var graphql = __webpack_require__(68240);
;// CONCATENATED MODULE: ./components/donation/DonationGrid.tsx









const DonationGrid = (param)=>{
    let { donations , eventId  } = param;
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const classHead = "p-2 md:p-3 border border-forumm-menu-border text-center font-bold";
    const classRow = "p-2 md:p-3 mt-2 text-center break-words";
    const getSymbol = (cr)=>{
        return cr ? currencies/* default */.Z === null || currencies/* default */.Z === void 0 ? void 0 : currencies/* default */.Z[cr === null || cr === void 0 ? void 0 : cr.toUpperCase()].symbol : "\xa3";
    };
    const getAmount = (amount, cr)=>{
        if (!amount) return "N/A";
        const value = typeof amount === "string" ? parseInt(amount, 10) : amount;
        return "".concat(getSymbol(cr !== null && cr !== void 0 ? cr : "")).concat((value / 100).toFixed(2));
    };
    const getFee = (tx)=>{
        if (!tx) return "";
        if (tx.paymentType === graphql/* PaymentType.DirectDebit */.uG.DirectDebit) return 0;
        if (!!tx.fee) return parseInt(tx.fee);
        return 0;
    };
    const [getFundraisingCSVData, { loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(GET_FUNDRAISING_CSV);
    const downloadCSV = async ()=>{
        const csv = await getFundraisingCSVData({
            variables: {
                eventId
            }
        }).then((d)=>{
            var ref;
            return (ref = d.data) === null || ref === void 0 ? void 0 : ref.getFundraisingCSV;
        });
        const blob = new Blob([
            "\uFEFF" + csv
        ], {
            type: "text/csv;charset=utf-8;"
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "donations.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex flex-col h-full w-full p-2 ml-6 md:ml-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex flex-row items-center justify-between mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "font-medium text-3xl",
                        children: "Organiser Overview"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "font-medium mr-6 md:mr-0",
                        children: [
                            (ref = donations === null || donations === void 0 ? void 0 : donations.length) !== null && ref !== void 0 ? ref : 0,
                            " donations"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "block sm:hidden text-center p-4",
                children: "To view this content, please use a larger device."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                color: "backgroundColourSecondary",
                className: "hidden sm:grid col-span-5 grid-cols-5 border-collapse text-xs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: classHead,
                        children: "Date"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: classHead,
                        children: "Donor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: classHead,
                        children: "Amount"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: classHead,
                        children: "Gift Aid"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: classHead,
                        children: "PaymentType"
                    }),
                    donations.sort((a, b)=>a.created && b.created ? a.created < b.created ? 1 : -1 : 0).map((tx)=>{
                        const totalAmount = tx.donation && parseInt(tx.donation) > 0 ? parseInt(tx.donation) + parseInt(tx.fee) : tx.amount;
                        const fee = getAmount(getFee(tx));
                        const isDD = tx.paymentType === graphql/* PaymentType.DirectDebit */.uG.DirectDebit;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid col-span-5 grid-cols-5 border-forumm-menu-border border-2 -mt-1",
                            style: {
                                background: theme.backgroundColourSecondary
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "".concat(classRow),
                                    children: tx.datetime
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "".concat(classRow),
                                    children: "".concat(tx.firstName, " ").concat(tx.lastName, " (").concat(tx.email, ")")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: classRow,
                                    children: getAmount(totalAmount, tx.currency)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: classRow,
                                    children: (tx === null || tx === void 0 ? void 0 : tx.giftAid) ? tx.giftAid.toUpperCase() : ""
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: classRow,
                                    children: (tx === null || tx === void 0 ? void 0 : tx.paymentType) ? tx.paymentType.toUpperCase() : "N/A"
                                }),
                                " "
                            ]
                        }, tx.created);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "w-full flex items-center justify-between pt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "text-center pl-3 md:pl-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: "Export CSV",
                        onClick: downloadCSV,
                        className: "ml-2 text-white whitespace-nowrap",
                        loading: loading
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var donation_DonationGrid = (DonationGrid);

// EXTERNAL MODULE: ./components/page/FooterUnauthenticated.tsx + 2 modules
var FooterUnauthenticated = __webpack_require__(79633);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/donation/[donationUrl]/index.tsx

































const stripePublicKey = "pk_live_jP3Sfq8LMnLnup6TR2O9tA6u";
function DonationPage(param) {
    let { eventDonationUrl  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    const router = (0,next_router.useRouter)();
    const donationUrl = eventDonationUrl || router.query.donationUrl;
    const { profile , isAdmin , isOrganizer , isLogged , canEditEvent  } = (0,useAuth/* useAuth */.aC)();
    const [isMounted, setIsMounted] = (0,react.useState)(false);
    const forceUSD = [
        "sussex-hardship-appeal-us"
    ].includes(donationUrl);
    const { data , loading: eventLoading , error: eventError  } = (0,useQuery/* useQuery */.a)(GetEventByDonationUrl/* GET_EVENT_BY_DONATION_URL */.I, {
        variables: {
            input: {
                donationUrl: donationUrl
            }
        },
        skip: !donationUrl
    });
    const [stripePromise, setStripePromise] = (0,react.useState)(null);
    const [merchantNotConfigured, setMerchantNotConfigured] = (0,react.useState)(false);
    const [loadingMerchantInfo, setLoadingMerchantInfo] = (0,react.useState)(true);
    const organizer = (ref = data === null || data === void 0 ? void 0 : data.getEventByDonationUrl.event) === null || ref === void 0 ? void 0 : ref.organizationName;
    const { profile: organisationProfile  } = (0,useOrganisationProfile/* useOrganisationProfile */.k)(organizer || "");
    (0,react.useEffect)(()=>{
        if (organisationProfile === null || organisationProfile === void 0 ? void 0 : organisationProfile.name) {
            setLoadingMerchantInfo(false);
            if (organisationProfile === null || organisationProfile === void 0 ? void 0 : organisationProfile.merchant) {
                const stripeAccount = organisationProfile.merchant;
                setStripePromise((0,stripe_esm/* loadStripe */.J)(stripePublicKey, {
                    stripeAccount
                }));
            } else {
                setMerchantNotConfigured(true);
            }
        }
    }, [
        organisationProfile
    ]);
    const selectedCurrency = forceUSD ? "USD" : organisationProfile.currency;
    const currencyInfo = currencies/* default */.Z[selectedCurrency.toUpperCase()];
    const platformFee = (organisationProfile === null || organisationProfile === void 0 ? void 0 : organisationProfile.percentage) !== undefined ? organisationProfile.percentage : 10;
    var ref16;
    const feeAbsorption = (ref16 = data === null || data === void 0 ? void 0 : (ref1 = data.getEventByDonationUrl) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fundraising) === null || ref2 === void 0 ? void 0 : ref2.feeAbsorption) !== null && ref16 !== void 0 ? ref16 : false;
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const dynamicStyle = (0,util/* getDynamicStyle */.nT)(theme.highlightColour);
    const [isDonationModalOpen, setDonationModalOpen] = (0,react.useState)(false);
    const [generalLoading, setGeneralLoading] = (0,react.useState)(false);
    const [hideDonationWheel, setHideDonationWheel] = (0,react.useState)(true);
    const [canGoBack, setCanGoBack] = (0,react.useState)(false);
    const [fetchDonations, { loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(EVENT_DONATON_LIST_TRANSACTIONS, {
        fetchPolicy: "network-only"
    });
    const [donationFormInitialValue, setDonationFormInitialValue] = (0,react.useState)({});
    const [donationData, setDonationData] = (0,react.useState)();
    const [programmeData, setProgrammeData] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        if (window && window.history && window.history.length > 2) {
            setCanGoBack(true);
        }
    }, []);
    const eventId = data === null || data === void 0 ? void 0 : data.getEventByDonationUrl.eventId;
    const fundraisingData = data === null || data === void 0 ? void 0 : (ref3 = data.getEventByDonationUrl) === null || ref3 === void 0 ? void 0 : ref3.fundraising;
    const eventDetails = data === null || data === void 0 ? void 0 : (ref4 = data.getEventByDonationUrl) === null || ref4 === void 0 ? void 0 : ref4.event;
    const getDonations = (0,react.useCallback)(()=>{
        if (eventId && !DONATION_WHEEL_CONFIG.disabled.includes(eventId)) {
            setHideDonationWheel(false);
        }
        fetchDonations({
            variables: {
                eventId: eventId,
                donationUrl: donationUrl
            }
        }).then((d)=>{
            var ref;
            var ref1;
            const payload = (ref1 = d === null || d === void 0 ? void 0 : (ref = d.data) === null || ref === void 0 ? void 0 : ref.eventDonationListTransactions.transactions.map((tx)=>{
                var ref, ref1;
                var _firstName, _lastName, _currency, _message, ref2, ref3, ref4, ref5, ref6, ref7;
                return {
                    amount: typeof (tx === null || tx === void 0 ? void 0 : tx.amount) === "number" ? tx === null || tx === void 0 ? void 0 : tx.amount : parseInt(tx.amount),
                    firstName: (_firstName = tx.firstName) !== null && _firstName !== void 0 ? _firstName : "Anonymous",
                    lastName: (_lastName = tx.lastName) !== null && _lastName !== void 0 ? _lastName : "",
                    currency: (_currency = tx.currency) !== null && _currency !== void 0 ? _currency : selectedCurrency,
                    message: (_message = tx.message) !== null && _message !== void 0 ? _message : undefined,
                    created: tx === null || tx === void 0 ? void 0 : tx.created,
                    datetime: (tx === null || tx === void 0 ? void 0 : tx.created) ? moment_default()(tx.created * 1000).format("DD/MM/YYYY HH:mm:ss") : "",
                    address: (ref2 = tx === null || tx === void 0 ? void 0 : tx.address) !== null && ref2 !== void 0 ? ref2 : undefined,
                    coverFee: (ref3 = tx === null || tx === void 0 ? void 0 : tx.coverFee) !== null && ref3 !== void 0 ? ref3 : undefined,
                    donation: typeof (tx === null || tx === void 0 ? void 0 : tx.donation) === "string" ? tx === null || tx === void 0 ? void 0 : tx.donation : tx === null || tx === void 0 ? void 0 : (ref = tx.donation) === null || ref === void 0 ? void 0 : ref.toString(),
                    fee: typeof (tx === null || tx === void 0 ? void 0 : tx.fee) === "string" ? tx === null || tx === void 0 ? void 0 : tx.fee : tx === null || tx === void 0 ? void 0 : (ref1 = tx.fee) === null || ref1 === void 0 ? void 0 : ref1.toString(),
                    giftAid: (ref4 = tx === null || tx === void 0 ? void 0 : tx.giftAid) !== null && ref4 !== void 0 ? ref4 : undefined,
                    selectedProgram: (ref5 = tx === null || tx === void 0 ? void 0 : tx.selectedProgram) !== null && ref5 !== void 0 ? ref5 : undefined,
                    email: (ref6 = tx === null || tx === void 0 ? void 0 : tx.email) !== null && ref6 !== void 0 ? ref6 : undefined,
                    visibility: (ref7 = tx === null || tx === void 0 ? void 0 : tx.visibility) !== null && ref7 !== void 0 ? ref7 : "Name & amount",
                    donorDob: tx === null || tx === void 0 ? void 0 : tx.donorDob,
                    paymentType: tx === null || tx === void 0 ? void 0 : tx.paymentType,
                    avatarUrl: "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/heart-and-hand-donation-icon.png"
                };
            })) !== null && ref1 !== void 0 ? ref1 : [];
            setGeneralLoading(false);
            const programmePayload = payload.filter((p)=>!!p.selectedProgram).map((tx)=>({
                    programme: tx.selectedProgram,
                    amount: tx.amount
                })).reduce((acc, tx)=>{
                if (tx.programme && tx.amount) {
                    var // @ts-ignore
                    ref;
                    const prevVal = (ref = acc[tx.programme.toUpperCase().trim().replaceAll(" ", "_")]) !== null && ref !== void 0 ? ref : 0;
                    // @ts-ignore
                    acc[tx.programme.toUpperCase().trim().replaceAll(" ", "_")] = prevVal + tx.amount / 100;
                }
                return acc;
            }, {});
            // @ts-ignore
            setProgrammeData(programmePayload);
            setDonationData(payload);
        });
    }, [
        donationUrl,
        eventId,
        fetchDonations
    ]);
    (0,react.useEffect)(()=>{
        getDonations();
    }, [
        getDonations
    ]);
    const isDarkTheme = theme.type === "DARK";
    var ref17;
    const eventImage = (ref17 = eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.bannerImage) !== null && ref17 !== void 0 ? ref17 : "https://assets.tumblr.com/images/default_header/optica_pattern_11.png";
    const eventData = data === null || data === void 0 ? void 0 : data.getEventByDonationUrl;
    const carouselItemsPrepare = prepareCarouselItems({
        media: (data === null || data === void 0 ? void 0 : (ref5 = data.getEventByDonationUrl) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fundraising) === null || ref6 === void 0 ? void 0 : ref6.media) || [],
        options: {
            coverImage: eventImage,
            title: data === null || data === void 0 ? void 0 : (ref7 = data.getEventByDonationUrl) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.fundraising) === null || ref8 === void 0 ? void 0 : ref8.title,
            description: data === null || data === void 0 ? void 0 : (ref9 = data.getEventByDonationUrl) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.fundraising) === null || ref10 === void 0 ? void 0 : ref10.description
        }
    });
    const checkAuth = (isPublished)=>{
        var ref, ref1, ref2, ref3;
        if (!isLogged) router.push("/");
        if (!isOrganizer && !isAdmin && !isPublished) router.push("/");
        if (!isAdmin && isOrganizer && (eventData === null || eventData === void 0 ? void 0 : (ref = eventData.event) === null || ref === void 0 ? void 0 : ref.organizationName) !== (profile === null || profile === void 0 ? void 0 : profile.university) && (eventData === null || eventData === void 0 ? void 0 : (ref1 = eventData.event) === null || ref1 === void 0 ? void 0 : ref1.organizationName) !== (profile === null || profile === void 0 ? void 0 : profile.company)) router.push("/");
        if (!isAdmin && !isOrganizer && (eventData === null || eventData === void 0 ? void 0 : (ref2 = eventData.event) === null || ref2 === void 0 ? void 0 : ref2.organizationName) !== (profile === null || profile === void 0 ? void 0 : profile.university) && (eventData === null || eventData === void 0 ? void 0 : (ref3 = eventData.event) === null || ref3 === void 0 ? void 0 : ref3.organizationName) !== (profile === null || profile === void 0 ? void 0 : profile.company)) router.push("/");
    };
    (0,react.useEffect)(()=>{
        if (isLogged && (eventData || eventError) && profile) setIsMounted(true);
        if (!isLogged && (eventData || eventError)) setIsMounted(true);
    }, [
        profile,
        eventData,
        isLogged,
        eventError
    ]);
    (0,react.useEffect)(()=>{
        if (eventError && !eventData && isMounted) {
            router.push("/");
        }
    }, [
        eventError,
        router,
        eventData,
        isMounted
    ]);
    (0,react.useEffect)(()=>{
        if (!!eventData && !eventLoading) {
            var ref;
            if (eventData.isPublished !== true) checkAuth(false);
            if (((ref = eventData.event) === null || ref === void 0 ? void 0 : ref.publiclyListed) !== true) checkAuth(eventData.isPublished === true);
        }
    }, [
        isMounted
    ]);
    if (!(eventData === null || eventData === void 0 ? void 0 : eventData.eventId)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar/* default */.Z, {});
    }
    var _title, ref18;
    // Added auto-generated default fundrasing programme.
    const programmes = [
        {
            description: eventDetails.description,
            goal: fundraisingData.goal,
            media: eventDetails.bannerImage,
            title: (_title = fundraisingData.title) !== null && _title !== void 0 ? _title : "Main Fund",
            active: true,
            enabled: true
        },
        ...(ref18 = fundraisingData === null || fundraisingData === void 0 ? void 0 : fundraisingData.programs) !== null && ref18 !== void 0 ? ref18 : []
    ];
    const pageUrl = "https://app.".concat("forumm.to").concat(router.asPath);
    const ogData = (()=>{
        var ref, ref1;
        const payload = {
            url: "https://images-prod.forumm.to/user-content/f23a4ed7-44e0-4176-a7d0-93f4efae2caa/jpa.png",
            alt: "Forumm",
            desc: "Event management and fundraising made simple."
        };
        if (!eventData || !eventData.event) return payload;
        if (!!eventData.event.bannerImage) {
            payload.url = eventData.event.bannerImage;
            var _shortDescription;
            payload.alt = (_shortDescription = eventData.event.shortDescription) !== null && _shortDescription !== void 0 ? _shortDescription : eventData.event.title;
        } else if (!!((ref = eventData.fundraising) === null || ref === void 0 ? void 0 : (ref1 = ref.media) === null || ref1 === void 0 ? void 0 : ref1[0])) {
            payload.url = eventData.fundraising.media[0].url;
            payload.alt = eventData.fundraising.media[0].title;
        }
        var _shortDescription1;
        payload.desc = (_shortDescription1 = eventData.event.shortDescription) !== null && _shortDescription1 !== void 0 ? _shortDescription1 : eventData.event.title;
        return payload;
    })();
    if (eventId === "7f31134c-bc71-490a-9705-7e0dfa085f8e" && donationData && ((ref11 = donationData[0]) === null || ref11 === void 0 ? void 0 : ref11.fee) !== "0") {
        donationData.unshift({
            amount: 600000,
            firstName: "GREN",
            lastName: "UK",
            currency: "gbp",
            message: "We are delighted to support such a wonderful cause.",
            created: 1736244994,
            datetime: "07/01/2025 10:16:34",
            coverFee: "no",
            donation: "600000",
            fee: "0",
            giftAid: "no",
            selectedProgram: "Launch Foods Foundation",
            visibility: "Name & amount",
            avatarUrl: "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/heart-and-hand-donation-icon.png"
        });
        donationData.unshift({
            amount: 250000,
            firstName: "Cruin",
            lastName: "Consulting",
            currency: "gbp",
            message: "Proud to support Launch foods as always.",
            created: 1736244994,
            datetime: "07/01/2025 10:16:34",
            coverFee: "no",
            donation: "250000",
            fee: "0",
            giftAid: "no",
            selectedProgram: "Launch Foods Foundation",
            visibility: "Name & amount",
            avatarUrl: "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/heart-and-hand-donation-icon.png"
        });
    }
    let mediaType = "VIDEO";
    let videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/video-background.mp4";
    if (donationUrl === "university-of-sussex-585354") {
        mediaType = "IMG";
        videoUrl = "https://s3.amazonaws.com/i.snag.gy/4y39rX.jpg";
    }
    if (eventData.eventId === "cd54965b-4538-44bf-b177-1f0837706cee") {
        mediaType = "IMG";
        videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Sussex+Banner+Option.png";
    }
    var ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: (ref19 = (ref12 = eventData.event) === null || ref12 === void 0 ? void 0 : ref12.title) !== null && ref19 !== void 0 ? ref19 : "Forumm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: ogData.desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: pageUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: ogData.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:alt",
                        content: ogData.alt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:type",
                        content: "image/jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "overflow-y-scroll overflow-x-hidden h-[calc(100vh)] -mt-[80px] pt-[80px] relative",
                children: [
                    stripePromise ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.Elements, {
                        stripe: stripePromise,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DonationForm/* default */.Z, {
                            eventDetails: eventDetails,
                            programs: programmes,
                            eventId: eventId,
                            isOpen: isDonationModalOpen,
                            setIsOpen: setDonationModalOpen,
                            organisationCurrency: selectedCurrency,
                            platformFee: platformFee,
                            feeAbsorption: feeAbsorption,
                            refetchDonations: ()=>{
                                setGeneralLoading(true);
                                setTimeout(()=>{
                                    getDonations();
                                }, 8000);
                            },
                            initialValue: donationFormInitialValue
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        color: "foregroundColour",
                        style: dynamicStyle,
                        className: "relative px-2 pt-9 pb-9 border-b border-forumm-menu-border",
                        children: [
                            mediaType === "VIDEO" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                autoPlay: true,
                                loop: true,
                                muted: true,
                                playsInline: true,
                                className: "absolute inset-0 w-full h-full object-cover select-none no-controls",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: videoUrl,
                                    type: "video/mp4"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: videoUrl,
                                alt: "Background Image",
                                className: "absolute inset-0 w-full h-full object-cover select-none"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "flex flex-col md:flex-row items-center justify-center space-y-6 md:space-y-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "rounded-2xl shadow-lg flex p-10 md:p-6 md:py-4 md:pt-6 md:pb-6 w-full md:w-[85%] max-w-[1500px] ".concat(isDarkTheme ? "" : "border border-forumm-menu-border"),
                                    color: "backgroundColorBanner",
                                    style: {
                                        background: isDarkTheme ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.6)",
                                        backdropFilter: "blur(5px)",
                                        WebkitBackdropFilter: "blur(5px)"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "hidden md:flex ml-2 items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "md:h-[250px] md:w-[250px] w-[250px] h-[240px] md:rounded-2xl rounded-md overflow-hidden flex flex-col justify-start items-center mx-auto md:ml-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "h-full w-full bg-cover bg-center",
                                                    style: {
                                                        backgroundImage: "url('".concat(eventImage, "')")
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "md:w-full ml-2 md:ml-20 md:mr-10 ml-0 flex",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                        className: "flex flex-row items-center mb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                alt: "Thumbnail Image",
                                                                className: "h-10 w-10 rounded-full mr-4 object-cover",
                                                                width: 30,
                                                                height: 30,
                                                                src: (ref20 = eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.thumbnailImage) !== null && ref20 !== void 0 ? ref20 : default_thumbnail/* default */.Z
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                className: "flex items-center text-[14px]",
                                                                children: eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.organizationName
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "text-[36px] w-full",
                                                        children: eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "mb-6",
                                                        style: {
                                                            whiteSpace: "pre-wrap"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* default */.Z, {
                                                            className: "text-[16px] md:text-[16px] mt-4 mb-4",
                                                            children: eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.shortDescription
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                        className: "mt-10 flex items-center space-x-4",
                                                        children: [
                                                            !loadingMerchantInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                title: "Donate",
                                                                onClick: ()=>{
                                                                    setDonationModalOpen(true);
                                                                },
                                                                type: "primary",
                                                                className: "rounded-full text-[14px] h-[40px] flex items-center justify-center self-end sm:self-center mr-8",
                                                                disabled: merchantNotConfigured
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                show: canGoBack,
                                                                className: "cursor-pointer hover:underline ${isDarkTheme ? '!text-forumm-active-blue' : '!text-forumm-white'} text-center text-sm flex justify-center items-center hover:animate-heartbeat",
                                                                onClick: ()=>router.back(),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineArrowBackIos */.oTp, {}),
                                                                    " Go Back"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                show: isOrganizer && canEditEvent(eventData),
                                                                className: "border-none text-xs flex items-center justify-center hover:underline hover:animate-heartbeat !ml-4",
                                                                title: "Edit",
                                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdEdit */.zmo, {
                                                                    fontSize: "1.5em"
                                                                }),
                                                                type: "tertiary",
                                                                size: "small",
                                                                onClick: ()=>{
                                                                    router.push("/create-event?id=".concat(eventId));
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "px-2 mt-[70px] mx-auto w-full md:w-[85%] max-w-[1500px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        color: "foregroundColour",
                                        className: "rounded-2xl flex flex-col sm:flex-row border border-forumm-menu-border flex-2 w-full sm:w-auto lg:w-[90%] xl:w-[85%] max-h-[90vh] overflow-y-auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "sm:w-2/5 flex flex-col flex-1 justify-start relative p-6 sm:p-10 md:p-12 lg:p-10 ml-6 md:ml-0 min-h-[64px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "flex flex-row items-center w-full mb-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            alt: "Thumbnail Image",
                                                            className: "h-16 w-16 rounded-full mr-4 block object-cover hover:animate-heartbeat",
                                                            width: 96,
                                                            height: 96,
                                                            src: (ref21 = eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.thumbnailImage) !== null && ref21 !== void 0 ? ref21 : default_thumbnail/* default */.Z
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "text-[22px] w-full",
                                                            children: eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.organizationName
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "text-[36px] w-full mt-4",
                                                    children: fundraisingData === null || fundraisingData === void 0 ? void 0 : fundraisingData.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "my-6",
                                                    style: {
                                                        whiteSpace: "pre-wrap"
                                                    },
                                                    children: (fundraisingData === null || fundraisingData === void 0 ? void 0 : fundraisingData.description) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextDisplay/* default */.Z, {
                                                        descriptionJson: fundraisingData === null || fundraisingData === void 0 ? void 0 : fundraisingData.description
                                                    }) : "No description provided."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "flex flex-col flex-1 w-full sm:w-auto",
                                        children: [
                                            !hideDonationWheel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                color: "foregroundColour",
                                                className: "rounded-2xl flex flex-col p-2 border border-forumm-menu-border w-full mb-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DonationProgressWheel, {
                                                    currentAmount: (ref22 = donationData === null || donationData === void 0 ? void 0 : donationData.reduce((acc, val)=>{
                                                        const amount = (val === null || val === void 0 ? void 0 : val.coverFee) === "no" || !(val === null || val === void 0 ? void 0 : val.coverFee) ? val === null || val === void 0 ? void 0 : val.amount : parseInt(val === null || val === void 0 ? void 0 : val.donation);
                                                        return amount / 100 + acc;
                                                    }, 0)) !== null && ref22 !== void 0 ? ref22 : 0,
                                                    donationGoal: (ref23 = data === null || data === void 0 ? void 0 : (ref13 = data.getEventByDonationUrl) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.fundraising) === null || ref14 === void 0 ? void 0 : ref14.goal) !== null && ref23 !== void 0 ? ref23 : 0,
                                                    numberOfDonators: (ref24 = donationData === null || donationData === void 0 ? void 0 : donationData.length) !== null && ref24 !== void 0 ? ref24 : 0,
                                                    currency: currencyInfo,
                                                    isLoading: loading || !data || generalLoading,
                                                    donationAction: ()=>setDonationModalOpen(true),
                                                    merchantNotConfigured: merchantNotConfigured,
                                                    loadingMerchantInfo: loadingMerchantInfo
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                color: "foregroundColour",
                                                className: "rounded-2xl flex flex-col flex-grow p-2 border border-forumm-menu-border w-full",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DonationWall, {
                                                    donations: donationData !== null && donationData !== void 0 ? donationData : [],
                                                    customClassName: hideDonationWheel ? "" : "max-h-[300px]",
                                                    donationAction: ()=>setDonationModalOpen(true)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0 mt-6 mb-8 h-full",
                                children: carouselItemsPrepare.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    color: "foregroundColour",
                                    className: "flex flex-2 flex-col size-full lg:w-[90%] xl:w-[85%] relative rounded-2xl overflow-hidden border border-forumm-menu-border py-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
                                        show: carouselItemsPrepare.length > 0,
                                        items: carouselItemsPrepare
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                show: ((ref25 = fundraisingData === null || fundraisingData === void 0 ? void 0 : fundraisingData.programs) !== null && ref25 !== void 0 ? ref25 : []).length > 0,
                                className: "flex items-stretch justify-between flex-wrap gap-4",
                                children: fundraisingData === null || fundraisingData === void 0 ? void 0 : (ref15 = fundraisingData.programs) === null || ref15 === void 0 ? void 0 : ref15.map((program)=>{
                                    var ref, ref1;
                                    var ref2;
                                    const raised = (0,util/* roundAmount */.Bq)((ref2 = programmeData === null || programmeData === void 0 ? void 0 : programmeData[program.title.toUpperCase().trim().replaceAll(" ", "_")]) !== null && ref2 !== void 0 ? ref2 : 0);
                                    var ref3;
                                    const currencySymbol = forceUSD ? "USD" : currencies/* default */.Z[(ref3 = (ref = eventData.event) === null || ref === void 0 ? void 0 : ref.currency) !== null && ref3 !== void 0 ? ref3 : "GBP"].symbol;
                                    const percentage = Number(raised) / Number(program.goal) * 100;
                                    var ref4, ref5;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                        className: "!rounded-2xl mb-4 max-w-[100%] sm:max-w-[30%] w-full overflow-hidden border border-forumm-menu-border min-h-[300px]",
                                        imgSrc: (ref4 = (ref1 = program.media) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref4 !== void 0 ? ref4 : default_thumbnail/* default.src */.Z.src,
                                        fixedWidth: false,
                                        ratio: "aspect-auto",
                                        onClick: ()=>{
                                            if (program.active) {
                                                setDonationFormInitialValue({
                                                    ...donationFormInitialValue,
                                                    selectedProgram: program.title.toUpperCase()
                                                });
                                                setDonationModalOpen(true);
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "flex size-full flex-col justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "flex justify-center flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-2xl",
                                                            children: program.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-sm text-left mt-1",
                                                            children: (0,util/* truncateString */.aS)((ref5 = program === null || program === void 0 ? void 0 : program.description) !== null && ref5 !== void 0 ? ref5 : "", 150)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                            className: "my-2",
                                                            style: {
                                                                opacity: program.goal || raised ? 1 : 0
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                    className: "flex justify-between text-sm",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                                    children: "".concat(currencySymbol).concat(raised)
                                                                                }),
                                                                                " Raised"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                                children: "".concat(currencySymbol).concat(program.goal)
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                    className: "mt-1 bg-forumm-white ".concat(isDarkTheme ? "" : "border border-forumm-menu-border", " rounded-xl"),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                        className: "h-2 rounded-xl bg-forumm-blue-light",
                                                                        style: {
                                                                            width: "".concat(Math.min(percentage, 100), "%")
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "flex justify-end gap-2 cursor-pointer w-full mt-2 hover:underline text-xs",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                disabled: !program.active,
                                                                title: !!program.active ? "Donate" : "Closed",
                                                                size: "full",
                                                                onClick: ()=>{
                                                                    setDonationFormInitialValue({
                                                                        ...donationFormInitialValue,
                                                                        selectedProgram: program.title.toUpperCase()
                                                                    });
                                                                    setDonationModalOpen(true);
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, "".concat(program.title.trim().replaceAll(" ", "_")));
                                })
                            }),
                            eventData && canEditEvent(eventData) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                color: "foregroundColour",
                                className: "rounded-2xl flex flex-col sm:flex-row p-2 border border-forumm-menu-border w-full flex-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(donation_DonationGrid, {
                                    donations: (ref26 = donationData === null || donationData === void 0 ? void 0 : donationData.filter((tx)=>{
                                        return tx === null || tx === void 0 ? void 0 : tx.created;
                                    })) !== null && ref26 !== void 0 ? ref26 : [],
                                    eventId: eventId !== null && eventId !== void 0 ? eventId : eventData.eventId
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "text-center mb-10 mt-10 cursor-pointer ".concat(isDarkTheme ? "!text-forumm-active-blue" : "!text-forumm-white", " hover:underline flex justify-center items-center hover:animate-heartbeat ").concat(window.self !== window.top ? "hidden" : ""),
                        onClick: ()=>router.back(),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineArrowBackIos */.oTp, {}),
                            " Back to Dashboard"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterUnauthenticated/* default */.Z, {
                        transparent: false
                    })
                ]
            })
        ]
    });
}
DonationPage.Layout = function Layout(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper/* UnauthenticatedWrapper */.j, {
        showFooter: false,
        children: children
    });
};


/***/ })

}]);